//-- Routing
(() => {
  const app = document.getElementById('app');
  if (!app) return;

  // Intercept internal link clicks
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a');
    if (!a) return;

    const raw = a.getAttribute('href');
    if (!raw || raw.startsWith('#')) return;

    const url = new URL(raw, location.origin);

    const isFile = url.pathname.match(/\.(pdf|jpg|png|zip|docx?)$/i);
    const hasMod = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
    const sameHost = url.host === location.host;
    const rootRelative = raw.startsWith('/');

    // Only intercept internal or root-relative links
    if ((!sameHost && !rootRelative) || isFile || hasMod || a.target === '_blank') return;

    e.preventDefault();

    // Normalize to root-absolute path
    const path = url.pathname.startsWith('/') ? url.pathname : '/' + url.pathname;
    navigate(path + url.search + url.hash);
  });

  // Handle browser back/forward
  window.addEventListener('popstate', () => {
    load(location.pathname, false);
  });

  async function navigate(path) { await load(path, true); }

  async function load(path, push = true) {
    const base = window.location.origin;         // always correct for where you are
    const url = new URL(path, base);  
    //console.log(url);
    // safely resolve /about-fathima → http://192.168.1.5/about-fathima
    url.searchParams.set('partial', '1');
    const sep = path.includes('?') ? '&' : '?';

    try {
      const res = await fetch(url + sep + 'partial=1', {
        headers: { 'X-Partial': '1', 'X-Requested-With': 'fetch' },
        cache: 'no-store'
      });
      if (!res.ok) throw new Error(res.statusText);

      const html = await res.text();
      app.innerHTML = html;

      if (push) history.pushState({}, '', path);

      document.dispatchEvent(new CustomEvent('partial:loaded'));
      window.scrollTo({ top: 0, behavior: 'instant' });
    } catch (err) {
      console.error('Partial load failed:', err);
      location.href = path; // fallback
    }
  }
})();